export {default as quadtree} from "./quadtree";



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/src/index.js
// module id = 2Si+
// module chunks = 0